export const EMAILJS_CONFIG = {
  serviceId: 'service_652hjel',
  templateId: 'template_7q357wa',
  publicKey: 'VpmCO_XLdd-Mw1IS2',
}
